import type { PropsWithChildren } from "react";
import { analyticsService } from "../services/analyticsService";
import { Helmet } from "react-helmet-async";
import { EventHelmet } from "@/components/helmets/eventHelmet";
import { recaptchaConfig } from "@/config/recaptcha";

const GoogleTagScript = () => (
  <Helmet>
    <script async src="https://www.googletagmanager.com/gtm.js?id=GTM-KLSVFF2"></script>
    <script async>
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-CSHBWMC49K");
        gtag("config", "AW-659948507");
      `}
    </script>
  </Helmet>
);

const RecaptchaScript = () => {
  return (
    <Helmet>
      <script
        src={`${recaptchaConfig.scriptUrl}?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`}
        async
        defer
      ></script>
    </Helmet>
  );
};

const VwoScript = () => (
  <Helmet>
    <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
    <script type="text/javascript" id="vwoCode" src="/scripts/vwo.js" async></script>
  </Helmet>
);

export const AppScriptsLauncher = ({ children }: PropsWithChildren<unknown>) => (
  <>
    <EventHelmet
      scriptSrc={"/scripts/posthog.js"}
      onScriptLoad={() => {
        analyticsService.startSessionRecording();
      }}
    >
      <script src="/scripts/posthog.js" async></script>
    </EventHelmet>
    <VwoScript />
    <GoogleTagScript />
    <RecaptchaScript />
    {children}
  </>
);
